import { NavLink } from "react-router";

import "./NavItems.scss";
import clsx from "clsx";
import { AgxTypography } from "@urbanx/agx.ui-components2";

const NavItem = ({ title, link }: { title: string; link: string }) => {
  return (
    <NavLink
      to={link}
      className={({ isActive }) => clsx("nav-item", { selected: isActive })}
    >
      <AgxTypography id='navItem' type='body' size='medium' color='#CDCDCD'>{title}</AgxTypography>
      <div className="nav-item-underline"></div>
    </NavLink>
  );
};

const NavItems = () => {
  return (
    <div className="nav-items">
      <NavItem title="Home" link="/" />
      <NavItem title="Quality Assurance" link="qualityassurance" />
      <NavItem title="User Acceptance Testing" link="useracceptancetesting" />
      <NavItem title="Pull Requests" link="pullrequests" />
      <NavItem title="Services" link="services" />
    </div>
  );
};

export default NavItems;
